/* eslint-disable no-console */
import {Flex} from 'antd';
import React from 'react';

import {ReactComponent as FeatureNo} from '../../assets/icons/FeatureNo.svg';
import {ReactComponent as FeatureYes} from '../../assets/icons/FeatureYes.svg';

const FeatureListing: React.FC<{data: any; isReadOnly: boolean}> = ({
  data,
  isReadOnly
}) => {
  return data?.map((dataItem: any, index: number) => {
    return (
      <Flex key={`FeatureListing${index}`} gap={6} align="center">
        <div
          className={`featureIconContainer ${
            dataItem?.isPresent && !isReadOnly ? 'greenBackground' : ''
          }`}
        >
          {dataItem?.isPresent && !isReadOnly ? <FeatureYes /> : <FeatureNo />}
        </div>
        <div className="featureLabel">{dataItem?.label}</div>
      </Flex>
    );
  });
};

export default FeatureListing;
